module.exports = __webpack_public_path__ + "img/icon-dzjh.3ab35c65.png";